import { render, staticRenderFns } from "./UserSettingsAccount.vue?vue&type=template&id=6f752efe&"
import script from "./UserSettingsAccount.vue?vue&type=script&lang=js&"
export * from "./UserSettingsAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f752efe')) {
      api.createRecord('6f752efe', component.options)
    } else {
      api.reload('6f752efe', component.options)
    }
    module.hot.accept("./UserSettingsAccount.vue?vue&type=template&id=6f752efe&", function () {
      api.rerender('6f752efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/base/UserSettings/UserSettingsAccount.vue"
export default component.exports